export const API_URL = "https://admin-womancart.appgrowthcompany.com/api";
export const NODE_API_URL =
  "https://womancart-appapinode.appgrowthcompany.com/";

export const END_POINTS = {
  // onboarding api
  login: "/login",
  loginWithPhone: "/loginWithPhone",
  signUp: "/register",
  verifyOtp: "/verifyOtp",
  resendOtp: "/resendOtp",
  updateProfile: "/updateProfile",
  getProfile: "/getProfile",
  imageUpload: "/imageUpload",
  verifyChangePhoneNumber: "/verify_change_phone_number",
  changePhoneNumber: "/change-phone-number",
  changeEmail: "/change-email",
  deleteAccount: "/account-deleted",
  forgotPassword: "/forgotPassword",
  changePassword: "/change-password",
  logout: "/logout",
  profile: "/getProfile",
  brands: "/brands",
  // getProducts: "/getProducts",
  // getProductDetails: "/getProductDetails",

  //blogs
  blogs: "/blogs",
  blogBySlug: "/blogs",

  //home
  dashboard: "node:/home/user/dashboard",
  CATEGORY_DASHBOARD: "node:/home/user/dashboard",
  product: "node:/product/user/list",
  category: "node:/product/user/category",
 




  getProducts: "/getProducts",
  getProductDetails: "/getProductDetails",

  CATEGORY_LIST: "node:/home/user/category-list",
  //cart
  addToCart: "/cart/add",
  getCart: "/cart/list",
  removeFromCart: "/cart/remove",
  placeOrder: "node:/order/user/place-order",
  getOrders: "node:/order/user/orders",
  getOrderById: "node:/order/user/orders",
  viewAllCategory: "node:/home/user/viewAllCategory",
  viewAllProduct: "node:/home/user/viewAllProduct",

  // Address
  addressList: "/address-list",
  addressCreate: "/address/create",
  addressEdit: "/address/edit",
  addressDelete: "/address",

  // Wishlist
  getWishlist: "/getWishlist",
  addWishlist: "/addWishlist",
  deleteWishlist: "/deleteWishlist",
  getCouponList: "/getCouponList",
  applyCoupon: "/applyCoupon",
  removedCoupon: "/removedCoupon",
  preferences: "/preferences",
  aboutUs: "/about-us",
  termsConditions: "/driver-term-condition",
  returnPolicy: "/return-policy",
  refundPolicy: "/refund-policy",
  faqs: "/faqs/customer",

  // Orders
  cancelOrder: "node:/order/user/cancel-order",
  returnOrder: "node:/order/user/return-order",
  rateOrder: "node:/order/user/rate-order",
  exchangeOrder: "node:/order/user/exchange-order",
  getExchangeProductDetails: "node:/order/user/product-details",
  searchAllProducts: "node:/home/user/search",
  FILTER_LIST: "node:/home/user/filter-list",
  verifyPayment: "node:/payment/verify-payment",
  walletTopUp: "node:/wallet/user/top-up",
  walletVerifyTopUp: "node:/wallet/user/verify-top-up",
  walletBalance: "node:/wallet/user/balance",
  walletHistory: "node:/wallet/user/history",
  getReferralStats: "node:/referral/user/stats",
  getReferralHistory: "node:/referral/user/history",
};
